import React, { useEffect, useState } from 'react'
import Bet_Full from "./PolaTarungSubComponents/PolaTarung_Bet_Full";
import Prize from './PolaTarungSubComponents/PolaTarung_Bet_Prize';
import Bet_Diskon from './PolaTarungSubComponents/PolaTarung_Bet_Deskon';
import { useDispatch, useSelector } from "react-redux";
import PolaTarungBetDiscountVersiWap from './PolaTarungSubComponents/PolaTarungBetDiscountVersiWap';
import PolaTarungBetFullVersiWap from './PolaTarungSubComponents/PolaTarungBetFullVersiWap';
import PolaTarungPrizeVersiWap from './PolaTarungSubComponents/PolaTarungPrizeVersiWap';
import VersiWAP from '../../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo';
import Rules from '../../../MobileDesign/FourDMo/Rules/Rules';
import { set4dGameSubChildtype, setCommonConfig } from '../../../../../redux/actions';
import MarketClose from "../../MarketClose";
import ZeroBalancePopup from "../../ZeroBalancePopup";
import GameClosedPopup from "../../GameClosedPopup";
import { withTranslation } from 'react-i18next';

const PolaTarung = (props) => {
  const dispatch = useDispatch();
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const user_profile = useSelector(state => state.UserProfile);
  const clickTab = useSelector((state) => state.CommonConfig.clickTab);
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: tabIndex == "1" ? "DISCOUNT" : tabIndex == "2" ? "FULLBET" : tabIndex == "3" ? "PRIZE" : "" }));

  };

  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = marketStatus.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = marketStatus.showMultipleFullbet;
    } else {
      multiple = marketStatus.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);

  useEffect(() => {
    setActiveTab(1)
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
  }, [gameId])

  useEffect(() => {
    setActiveTab(1);
    dispatch(setCommonConfig({ key: 'gameType', value: 'polatarung' }));
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
    dispatch(setCommonConfig({ key: 'clickTab', value: 0 }));
  }, [clickTab])

  return (
    <>
      <div className="inner_nav-tabwrapper">
        {marketStatus.fullbetStatus == 0 && marketStatus.prize123Status == 0 ? '' :

          <div
            className={`inner_tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          >
            DISCOUNT
          </div>
        }
        {marketStatus.fullbetStatus == 0 ? '' :

          <div
            className={`inner_tab ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            FULLBET
          </div>
        }
        {marketStatus.prize123Status == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 3 ? "active" : ""}`}
            onClick={() => handleTabClick(3)}
          >
            PRIZE 1,2,3
          </div>
        }
      </div>
      {
        device === "Mobile" ? (
          <>
            {/* --- Rules ---  */}
            {app_type === "wap" ?
              <div className='rules_container'>
                <div>
                  <p>{props.t('polatarung_text')}</p>
                  <p>(Pisahkan dengan Koma)</p>
                  <p>Contoh : As : 1234  Kop : 4567  Kepala : 6789  Ekor :5678</p>
                </div>
                <div className='rules_conversion'>
                  <p>Konversi <br /> 1 = {multipleValue}</p>
                </div>
              </div>
              : ""}
          </>
        ) : null
      }
      <div className="tabcontent-wrapper">
        {activeTab === 1 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <PolaTarungBetDiscountVersiWap /> : <Bet_Diskon />))}</div>}
        {activeTab === 2 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <PolaTarungBetFullVersiWap /> : <Bet_Full />))}</div>}
        {activeTab === 3 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <PolaTarungPrizeVersiWap /> : <Prize />))}</div>}
      </div>
    </>
  )
}

export default withTranslation()(PolaTarung)
